import React, { useState, useEffect } from "react";
import { ShowRunTimeSlotDto } from "@eagerdog/interfaces";

import Button from "src/components/Button/Button";
import Input from "src/components/Input/Input";
import { Modal, useModal } from "src/components/Modal/Modal";
import Confirm from "src/components/Confirm/Confirm";
import { ShowRunTimeSlotDtoId } from "src/components/StepForm/ShowForm/ShowForm";

import "./Timeslots.scss";

interface IProps {
  timeslots?: ShowRunTimeSlotDto[],
  disableReorder?: boolean,
  onChange(timeslots: ShowRunTimeSlotDtoId[]): void
}

const Timeslots: React.FC<IProps> = (props) => {
  const defaultTimeslot = {
    time_slot: "",
    num_available: 0,
    note: ""
  };

  const [loaded, setLoaded] = useState<boolean>(false);
  const [timeslots, setTimeslots] = useState<ShowRunTimeSlotDtoId[]>([{...defaultTimeslot}]);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const { isShown: isDeleteShown, toggle: toggleDelete } = useModal();

  const addAnother = () => {
    let _timeslots = JSON.parse(JSON.stringify(timeslots));
    _timeslots.push({...defaultTimeslot});

    setTimeslots(_timeslots);
  }

  const removeTimeslot = (index: number) => {
    let _timeslots = JSON.parse(JSON.stringify(timeslots));
    _timeslots.splice(index, 1);
    setTimeslots(_timeslots.length > 0 ? _timeslots : []);
  }

  const moveTimeslot = (index: number, direction: "up" | "down") => {
    const swapIndex = direction === "up" ? index - 1 : index + 1;
    if (swapIndex < 0 || swapIndex >= timeslots.length) return;
    const _timeslots = JSON.parse(JSON.stringify(timeslots));
    [_timeslots[index], _timeslots[swapIndex]] = [_timeslots[swapIndex], _timeslots[index]];
    setTimeslots(_timeslots);
  }

  const setTimeslot = (index: number, t: ShowRunTimeSlotDtoId) => {
    let _timeslots = JSON.parse(JSON.stringify(timeslots));
    _timeslots[index] = t;

    setTimeslots(_timeslots);
  }

  useEffect(() => {
    if (!loaded) {
      const hydrateTimeslots = () => {
        let _timeslots = JSON.parse(JSON.stringify(props.timeslots));
        setTimeslots(_timeslots);
      }

      if (props.timeslots) {
        hydrateTimeslots();
      }

      setLoaded(true);
    }
  }, [loaded, setLoaded, props.timeslots]);

  useEffect(() => {
    props.onChange(timeslots);
  }, [timeslots, props]);

  return (
    <div className="Timeslots">
      {timeslots.map((t: ShowRunTimeSlotDtoId, index: number) => {
        return(
          <div className={"timeslot slot"+index} key={"slot"+index}>
            <div className="timeslotData">
              <div className="nameTotal">
                <Input required={true} type="text" onChange={(e:any) => { setTimeslot(index, {...t, time_slot: e.target.value }); }} label="Timeslot Label" placeholder="ex. 9:00AM, Morning, etc." defaultValue={t.time_slot} />
                <Input required={true} type="number" min="1" onChange={(e:any) => { setTimeslot(index, {...t, num_available: Number(e.target.value) }); }} label="Dog Limit" defaultValue={t.num_available.toString()} />
              </div>
              <div className="note">
                <Input type="text" onChange={(e:any) => { setTimeslot(index, {...t, note: e.target.value }); }} label="Note (optional)" placeholder={"ex. 'Early Birds Only'"} defaultValue={t.note} maxLength={40} />
              </div>
            </div>
            <div className="timeslotActions">
              <div className="btnWrap"><Button disabled={props.disableReorder || index === 0} onClick={(e) => { e.preventDefault(); moveTimeslot(index, "up"); }} className="moveUp">Up</Button></div>
              <div className="btnWrap"><Button disabled={props.disableReorder || index === timeslots.length - 1} onClick={(e) => { e.preventDefault(); moveTimeslot(index, "down"); }} className="moveDown">Down</Button></div>
              <div className="btnWrap deleteWrap"><Button onClick={(e) => { e.preventDefault(); setDeleteIndex(index); toggleDelete(); }} className="delete">Delete</Button></div>
            </div>
          </div>
        );
      })}
      <div className="actions">
        <Button onClick={(e) => { e.preventDefault(); addAnother(); }}>Add Timeslot</Button>
      </div>
      <Modal
        className="Confirmation"
        isShown={isDeleteShown}
        hide={toggleDelete}
        modalContent={
          <Confirm
            message="Are you sure you want to delete this timeslot?"
            onConfirm={() => {
              if (deleteIndex !== null) removeTimeslot(deleteIndex);
              setDeleteIndex(null);
              toggleDelete();
            }}
            onCancel={() => {
              setDeleteIndex(null);
              toggleDelete();
            }}
          />
        }
      />
    </div>
  );
};

export default Timeslots;